import { format } from "date-fns"
import { Button } from "@mui/material"
import { observer } from "mobx-react-lite"
import { store } from "../../../stores/Store"
import { AlertModal, DisplayValue } from "../../.."
import { ToolDetailRow } from "../profile/ProfileTool"
import LogoUpdate from "../../form/admin/AccountLogoForm"
import AccountQuestionnaireEnableButton from "../../form/admin/AccountQuestionnaireEnableButton"
import IsAllowed from "../../../models/Permissions"
import AccountUsers from "./AccountUsers"
import { UserCreateForm } from "../../form/admin/UserForms"
import AccountAuthConfigForm from "../../form/admin/AccountAuthConfigForm"
import { AccountEditForm } from "../../form/admin/AccountForms"
import { Icons } from "../../../misc/Icons"
import QuestionnaireSettingsForm from "../questionnaire/QuestionnaireSettingsForm"
import { UTCDate } from "@date-fns/utc"
import AccountJobs from "./AccountJobs"


interface AccountDetailsProps {
    account: any;
}


export default observer(function AccountDetails ({account}: AccountDetailsProps) {

    const { sessionState, checkJwtRoles } = store.AppStore

    return (
        <div style={{display: "grid", gap: "20px", overflowY: "scroll", paddingRight: "20px"}}>
            {account?.accountType !== "admin" ? (
                <div className="tool-section" style={{maxWidth: "700px"}}>
                    <div className="tool-table">
                        <ToolDetailRow label={DisplayValue("dict_key", "accountName")}                  value={account.accountName} />
                        <ToolDetailRow label={DisplayValue("dict_key", "Organisation UID")}             value={account.advisorUid} />
                        <ToolDetailRow label={DisplayValue("dict_key", "accountType")}                  value={account.accountTypeDisplay} />
                        <ToolDetailRow label={DisplayValue("dict_key", "customerType")}                 value={DisplayValue("customer_type", account.customerType)} />
                        <ToolDetailRow label={DisplayValue("dict_key", "organisationType")}             value={DisplayValue("org_type", account.organisationType)} />
                        <ToolDetailRow label={DisplayValue("dict_key", "organisationActivity")}         value={DisplayValue("org_activity", account.organisationActivity)} />
                        <ToolDetailRow label={DisplayValue("dict_key", "phone")}                        value={account.phone} />
                        <ToolDetailRow label={DisplayValue("dict_key", "addressLine1")}                 value={account.addressLine1} />
                        <ToolDetailRow label={DisplayValue("dict_key", "city")}                         value={account.city} />
                        <ToolDetailRow label={DisplayValue("dict_key", "postcode")}                     value={account.postcode} />
                        <ToolDetailRow label={DisplayValue("dict_key", "countryId")}                    value={DisplayValue("countries", account.countryId)} />
                        
                        {account.customerType === "N" ? (
                            <>
                                <ToolDetailRow label={DisplayValue("dict_key", "regulator")}                    value={DisplayValue("ni_regulator", account.regulator)} hidden={account.accountType !== "customer"} />
                                <ToolDetailRow label={DisplayValue("dict_key", "regulatorRegistrationNumber")}  value={account.regulatorRegistrationNumber} hidden={account.accountType !== "customer"} />                           
                            </>
                        ) : null}
                        
                        {account.accountType === "sponsor" ? (
                            <>
                                <ToolDetailRow label={DisplayValue("dict_key", "sponsorLicenceNum")}            value={account.sponsorLicenceNum} />
                                <ToolDetailRow label={DisplayValue("dict_key", "sponsorStartDate")}             value={account.sponsorStartDate ? format(new UTCDate(account.sponsorStartDate), "dd/MM/yyyy") : ""} />
                                <ToolDetailRow label={DisplayValue("dict_key", "sponsorExpiryDate")}            value={account.sponsorExpiryDate ? format(new UTCDate(account.sponsorExpiryDate), "dd/MM/yyyy") : ""} />
                            </>
                        ) : null}
                    </div>
                </div>
            ): null}

            <div style={{display: "flex", gap: "10px", flexFlow: "wrap"}}>
                {account?.accountType !== "admin" && IsAllowed(account, "UPDATE") ? (
                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={!!sessionState}
                        onClick={() => {
                            AlertModal({title: `Edit account`, body: (
                                <AccountEditForm
                                    account={account}
                                    onSuccess={async () => {
                                        await store.ToolStore.getAccount()
                                        store.AlertStore.Close()
                                    }}
                                />
                            )})
                        }}>
                        Edit account
                    </Button>
                ) : null}

                {checkJwtRoles(["account_manager"]) ? (
                    <Button
                        color="error"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={!!sessionState}
                        onClick={() => {
                            AlertModal({body: <AccountAuthConfigForm account={account} />, size: "auto"})
                        }}>
                        <Icons.Settings /> Authentication settings
                    </Button>
                ) : null}
            </div>

            {store.AppStore.checkJwtRole("account_manager") ? (
                <AccountUsers account={account} />
            ) : null}
        </div>
    )
})